@if (collection) {
  <div class="container single-view" id="edit-collection">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/collections/' + collectionId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'COLLECTIONS.BTN_BACK_TO_COLLECTION' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-collection-title" class="section-title">{{ 'COLLECTION_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="collectionForm"  data-testid="edit-collection-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-collection-details-title" class="border-b pb-3">{{ 'COLLECTION_UPDATE.COLLECTION_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-collection-field-name"class="block text-sm" for="name">{{ 'COLLECTION_UPDATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-collection-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                    @if (collectionForm.get('name')?.invalid && collectionForm.get('name')?.touched) {
                      <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-collection-field-code" class="block text-sm" for="code">{{ 'COLLECTION_UPDATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-collection-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                    @if (collectionForm.get('code')?.invalid && collectionForm.get('code')?.touched) {
                      <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-collection-field-hasParent" class="block text-sm mb-3" for="hasParent">{{ 'COLLECTION_UPDATE.HAS_PARENT' | translate }}</label>
                    <span class="inline-flex mr-6">
                      <label for="yes" data-testid="edit-collection-has-parent-yes-label" class="inline-flex items-center cursor-pointer">
                        <p-radioButton data-testid="edit-collection-has-parent-yes" name="hasParentCollection" value="true" formControlName="hasParentCollection" inputId="yes" />
                        <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                      </label>
                    </span>
                    <span class="inline-flex mr-2">
                      <label for="no" data-testid="edit-collection-has-parent-no-label" class="inline-flex items-center cursor-pointer">
                        <p-radioButton data-testid="edit-collection-has-parent-no" name="hasParentCollection" value="false" formControlName="hasParentCollection" inputId="no" />
                        <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                      </label>
                    </span>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{'disabled': collectionForm.get('hasParentCollection')?.value == 'false'}">
                    <label class="block text-sm" for="parentCollection">{{ 'COLLECTION_UPDATE.PARENT_COLLECTION' | translate }}</label>
                    <app-custom-dropdown
                      data-testid="parentcollection"
                      [placeholder]="'COLLECTION_UPDATE.SELECT_PARENT_PLACEHOLDER' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="collectionsRowsPerPageOption"
                      [totalCount]="collectionsTotalRecords"
                      [totalPages]="getTotalPages(collectionsTotalRecords, collectionsRowsPerPageOption)"
                      [options]="collectionsList"
                      formControlName="collection"
                      (onLazyLoad)="onLazyLoadCollections($event)">
                    </app-custom-dropdown>
                    @if (collectionForm.errors?.['requiredCollection'] && isCollectionRequired()) {
                      <small data-testid="parent-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-collection-update-collection-button" class="btn primary-btn" [disabled]="collectionForm.invalid" (click)="submitForm()">{{
                      'COLLECTION_UPDATE.BTN_UPDATE_COLLECTION' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
